<template>
  <div
    v-if="loading"
    :class="{
      center: !center,
    }"
  >
    <md-progress-spinner
      :md-diameter="diameter"
      :md-stroke="stroke"
      md-mode="indeterminate"
    />
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    center: Boolean,
    loading: Boolean,
    diameter: {
      type: Number,
      default: 100,
    },
    stroke: {
      type: Number,
      default: 10,
    },
  },
}
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
  padding-top: 25vh;
}
</style>
